import { render, staticRenderFns } from "./FDOCreate.vue?vue&type=template&id=2f93c0a3&scoped=true&"
import script from "./FDOCreate.vue?vue&type=script&lang=js&"
export * from "./FDOCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f93c0a3",
  null
  
)

export default component.exports